import { Navigate } from 'react-router-dom';
import React, { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { inboxLoginStatus } from '@/state/inboxAuth';
import routes from '@/components/inbox/routes';

export type UnauthenticatedRouteProps = PropsWithChildren;

const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = ({ children }) => {
  const loginStatus = useAtomValue(inboxLoginStatus);

  if (loginStatus === 'LOGGED_IN') {
    return <Navigate to={routes.inbox} replace />;
  }

  return <>{children}</>;
};

export default UnauthenticatedRoute;
